const customs = {
    en: {
        "customs.title": "Customs calculator",
        "customs.value": "Customs value (CIF)",
        "customs.engine": "Engine (cc)",
        "customs.age": "Age (years)",
        "customs.fuel": "Fuel",
        "customs.fuel_petrol": "Petrol/Diesel",
        "customs.fuel_electric": "Electric",
        "customs.calc": "Calculate",
        "customs.importDuty": "Import duty",
        "customs.excise": "Excise",
        "customs.vat": "VAT",
        "customs.clearanceFee": "Clearance fee",
        "customs.total": "Total customs cost",
        "customs.disclaimer": "Estimate based on configured rates; not an official quote.",
        "customs.rates": "Rates (admin)",
        "customs.vatPercent": "VAT %",
        "customs.dutyPercent": "Import duty %",
        "customs.excisePerCc": "Excise per cc",
        "customs.ageNewMax": "New up to (yrs)",
        "customs.ageOldMin": "Old from (yrs)",
        "customs.coefNew": "Coef (new)",
        "customs.coefMid": "Coef (mid)",
        "customs.coefOld": "Coef (old)",
        "customs.clearance": "Clearance fee",
        "customs.saveRates": "Save rates",
    },
    ru: {
        "customs.title": "Калькулятор растаможки",
        "customs.value": "Таможенная стоимость (CIF)",
        "customs.engine": "Двигатель (см³)",
        "customs.age": "Возраст (лет)",
        "customs.fuel": "Топливо",
        "customs.fuel_petrol": "Бензин/Дизель",
        "customs.fuel_electric": "Электро",
        "customs.calc": "Рассчитать",
        "customs.importDuty": "Пошлина",
        "customs.excise": "Акциз",
        "customs.vat": "НДС",
        "customs.clearanceFee": "Сбор за оформление",
        "customs.total": "Итого растаможка",
        "customs.disclaimer": "Оценка по заданным ставкам; не официальный расчёт.",
        "customs.rates": "Ставки (админ)",
        "customs.vatPercent": "НДС %",
        "customs.dutyPercent": "Пошлина %",
        "customs.excisePerCc": "Акциз за см³",
        "customs.ageNewMax": "Новый до (лет)",
        "customs.ageOldMin": "Старый от (лет)",
        "customs.coefNew": "Коэф (новый)",
        "customs.coefMid": "Коэф (средн.)",
        "customs.coefOld": "Коэф (старый)",
        "customs.clearance": "Сбор",
        "customs.saveRates": "Сохранить ставки",
    },
    geo: {
        "customs.title": "განბაჟების კალკულატორი",
        "customs.value": "საბაჟო ღირებულება (CIF)",
        "customs.engine": "ძრავა (სმ³)",
        "customs.age": "ასაკი (წელი)",
        "customs.fuel": "საწვავი",
        "customs.fuel_petrol": "ბენზინი/დიზელი",
        "customs.fuel_electric": "ელექტრო",
        "customs.calc": "გამოთვლა",
        "customs.importDuty": "საიმპორტო გადასახადი",
        "customs.excise": "აქციზი",
        "customs.vat": "დღგ",
        "customs.clearanceFee": "განბაჟების მოსაკრებელი",
        "customs.total": "ჯამური განბაჟების ღირებულება",
        "customs.disclaimer": "შეფასება მითითებული განაკვეთებით; არ არის ოფიციალური ანგარიში.",
        "customs.rates": "განაკვეთები (ადმინი)",
        "customs.vatPercent": "დღგ %",
        "customs.dutyPercent": "საიმპორტო გადასახადი %",
        "customs.excisePerCc": "აქციზი სმ³-ზე",
        "customs.ageNewMax": "ახალი — მდე (წელი)",
        "customs.ageOldMin": "ძველი — დან (წელი)",
        "customs.coefNew": "კოეფ. (ახალი)",
        "customs.coefMid": "კოეფ. (საშუალო)",
        "customs.coefOld": "კოეფ. (ძველი)",
        "customs.clearance": "მოსაკრებელი",
        "customs.saveRates": "განაკვეთების შენახვა",
    },
};

export default customs;
